var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.current
    ? _c(
        "div",
        { staticClass: "doc-viewer" },
        [
          _c(_vm.current.component, { tag: "component" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "doc-viewer__history" },
            [
              _c("DocHistory", {
                attrs: { "doc-key": _vm.docKey, value: _vm.current.value },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }